<template lang="pug">
div.wrap-module-edit-comic-episodes
  NowLoading(:show="isSaving" :overlayColor="pallete.$overlay_color")
  div.edit-comic-episodes-content
    div.wrap-info.py20
      div.f.fm.mb6
        span.bold.fz16.block {{comic.title}}
        a(:href="comicURL" target="_blank").pb2.ml6
          v-icon(size="16px") mdi-open-in-new
      span.block.fz14.line-clamp-3 {{comic.about}}
    div.wrap-episodes.py20
      div.f.fm.flex-between.mb12
        span.label.block エピソード：
        span(@click="addEpisode").btn-add-episode.fz14.px12.py8.cursor-pointer エピソードを追加
      div.wrap-episodes-list
        ItemEditComicEpisodeList(v-for="episode in episodes"
          :key="episode.id" :episode="episode" :episodes="episodes"
          @updateEpisodes="$emit('updateEpisodes')")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-edit-comic-episodes {
  padding-top: $header_height;
  .edit-comic-episodes-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    .wrap-info {
      border-bottom: $basic_border;
    }
    .wrap-episodes {
      .label {
        color: $secondary_text_color;
      }
      .btn-add-episode {
        color: $dark_primary_text_color;
        background: $active_color;
        border-radius: 3px;
      }
      .wrap-episodes-list {
        border-top: $basic_border;
      }
    }
  }
}
</style>

<script>
import { domain } from '@/components/utils/config'
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import NowLoading from '@/components/shared/NowLoading'
import ItemEditComicEpisodeList from '@/components/item/ItemEditComicEpisodeList'

export default {
  components: {
    NowLoading,
    ItemEditComicEpisodeList
  },
  props: {
    comic: {
      type: Object,
      required: true
    },
    episodes: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    comicURL () {
      return `${domain}/comic/${this.comic.id}`
    }
  },
  data () {
    return {
      isSaving: false
    }
  },
  methods: {
    async addEpisode () {
      if (this.isSaving) return
      this.isSaving = true

      const rp = this.$route.params
      let episodeObj = {
        title: `第${this.episodes.length + 1}話`,
        status: 'draft',
        createdBy: this.uid,
        createdAt: new Date(),
        updatedAt: new Date()
      }
      const lastEpisode = this.episodes[this.episodes.length - 1]
      if (lastEpisode) episodeObj.prev = lastEpisode.id
      
      const newEpisodeId = await database
        .episodeCollection(rp.comicId)
        .add(episodeObj)

      const pageObj = {
        pageColor: '#ffffff',
        size: { w: 800, h: 1200 },
        createdBy: this.uid,
        createdAt: new Date(),
        updatedAt: new Date(),
      }
      const newPageId = await database
        .pageCollection(rp.comicId, newEpisodeId)
        .add(pageObj)

      await database.episodeCollection(rp.comicId)
        .update(newEpisodeId, { currentPage: newPageId })
      
      this.$router.push(`/edit-comic/${rp.comicId}/${newEpisodeId}/${newPageId}`)

      this.isSaving = false

      this.sendMixpanelEvent({ msg: 'onBtnToAddEpisode', info: episodeObj })
    }
  }
}
</script>
